import ajax from '@/resources/myApi';

const service = {
    getCaseStatus,
    getCases,
    getChannels,
};

async function getCaseStatus() {
    try {
        const { data } = await ajax.get(`api/CaseStatusLookupView`,
            { name: 'Case Status Lookup View' }
        );

        return data;
    } catch (error) {
        return [];
    }
}

async function getChannels() {
    try {
        const { data } = await ajax.get(`api/ChannelLookupView`,
            { name: 'Channel Look up View' }
        );

        return data;
    } catch (error) {
        return [];
    }
}

async function getCases
    (
        pageNumber,
        pageSize,
        sortOrder,
        sortBy,
        filters
    ) {

    const params = {
        pageNumber,
        pageSize,
        sortOrder,
        sortBy,
        filters
    };

    try {
        const { data } = await ajax.get('api/case/', {
            name: 'cases',
            params
        });

        return data;
    } catch (error) {
        return {};
    }
}

export default service;